import { Alert, AlertTitle, Box, Button, CircularProgress, Container, FormControl, TextField, Typography } from "@mui/material";
import { FC, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { forgotPasswordChange, ForgotPasswordChangePayload } from "src/apis/auth";

const RecoverPassword: FC = () => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [query] = useSearchParams();
  const navigate = useNavigate();

  const isNewPasswordValid = useMemo<boolean>(() => newPassword.length >= 8, [newPassword]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setLoading(true);

    const payload: ForgotPasswordChangePayload = {
      new_password: newPassword,
      code: query.get("code") ?? "",
      token: query.get("token") ?? "",
    }

    try {
      await forgotPasswordChange(payload)

      setSuccess(true);
      setError("");
    } catch(err: any) {
      setSuccess(false);
      setError(err?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
        textAlign: "center",
        // backgroundColor: "#ffe7db",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "90%",
          maxWidth: "400px",
          borderRadius: "16px",
          padding: "40px",
          paddingBottom: "30px",
          gap: "3rem",
        }}
      >
        <Typography fontSize={40} fontFamily="monospace" fontWeight={600}>
          Eezycare
        </Typography>

        {!success && (
          <Typography>
            Preencha o formulário abaixo para redefinir sua senha
          </Typography>
        )}

        <FormControl
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
          onSubmit={handleSubmit}
        >
          {Boolean(error) && (
            <Alert severity="error">
              <AlertTitle>
                {error}
              </AlertTitle>
            </Alert>
          )}

          {success ? (
            <Alert severity="success" icon={<></>}>
              <AlertTitle>
                Senha redefinida com sucesso!
              </AlertTitle>

              <Button
                variant="contained"
                type="button"
                color="success"
                onClick={() => {
                  navigate("/login");
                }}
              >
                Voltar para login
              </Button>
            </Alert>
          ) : (
            <Box>
              <TextField
                required
                fullWidth
                disabled={success}
                label="Nova Senha"
                type={"password"}
                InputLabelProps={{ required: false }}
                helperText={!isNewPasswordValid && "A sua nova senha precisa ter no mínimo 8 caracteres" }
                onChange={(e) => {
                  setNewPassword(e.target.value)
                }}
              />

              <Button
                variant="contained"
                type="submit"
                disabled={loading || !isNewPasswordValid}
                sx={{
                  width: "100%",
                  height: '56px',
                  marginTop: "0.5em",
                }}
              >
                {loading ? (
                  <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}>
                    <CircularProgress
                      size="1.25rem"
                      sx={{
                        marginRight: 1
                      }}
                    /> Enviando...
                  </Box>
                ) : (
                  <Box>Enviar</Box>
                )}
              </Button>
            </Box>
          )}
        </FormControl>
      </Box>
    </Container>
  );
}

export default RecoverPassword;
